import React from 'react';
import uniqid from 'uniqid';

import Divider from 'components/shared/others/divider/divider';

import { useCurrentUser } from 'state/current-user/current-user.thunk';

import { formatValue } from 'helpers/format-value';

interface ConsultantListProps {
  customClass?: string;
}

interface ConsultantUser {
  firstName?: string;
  lastName?: string;
  officePhone?: string;
  email?: string;
}

interface Consultant {
  id?: string | number;
  consultantType?: string;
  user?: ConsultantUser;
}

interface CurrentUserData {
  client?: {
    consultants?: Consultant[];
  };
}

const ConsultantList = ({
  customClass,
}: ConsultantListProps): React.JSX.Element => {
  const user = useCurrentUser() as unknown as {
    data?: CurrentUserData;
  };

  const principal =
    user &&
    user.data &&
    user.data.client &&
    user.data.client.consultants &&
    user.data.client.consultants.find(
      (consultant) => consultant.consultantType === 'PRINCIPAL',
    );

  const contact =
    user &&
    user.data &&
    user.data.client &&
    user.data.client.consultants &&
    user.data.client.consultants.find(
      (consultant) => consultant.consultantType === 'CONTACT',
    );

  return (
    <div className={customClass}>
      {contact || principal ? (
        ([principal, contact].filter((c) => c) as Consultant[]).map(
          (consultant, i) => (
            <div key={uniqid()}>
              <div
                key={consultant.id}
                className="flex items-baselibe flex-wrap gap-3"
              >
                <div>
                  <div className="text-lg font-family font-black text-navy-800 mb-2">
                    {consultant.user?.firstName} {consultant.user?.lastName}
                  </div>

                  <div className="mb-2">
                    <p className="text-sm font-medium">
                      {consultant.user?.officePhone &&
                        formatValue(consultant.user.officePhone, 'phone')}
                    </p>
                    <p className="text-sm font-medium">
                      {consultant.user?.email}
                    </p>
                  </div>
                  <a
                    href={`mailto:${consultant.user?.email}`}
                    className="inline-block transition-all text-gray-600 border border-gray-300 px-4 py-2 bg-gradient-to-t from-neutral-50 to-white rounded-lg leading-tight shadow-default hover:from-white hover:to-white active:bg-gradient-to-t active:from-white active:to-neutral-50 text-base font-normal focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                  >
                    Send an email
                  </a>
                </div>
              </div>

              {i === 0 && <Divider customClass="!my-6" />}
            </div>
          ),
        )
      ) : (
        <>No consultants assigned yet.</>
      )}
    </div>
  );
};

export default ConsultantList;
